/** localStorage key for TAP-issued JWT (username/password auth) */
export const LOCAL_AUTH_TOKEN_KEY = 'tap_local_jwt';
